import qs from 'qs';
import { serviceApi } from '~/api';

export const config = {
  PostcodeSearchForm: {
    checkPostcodeAvailability: postcode => serviceApi.fetch(`availability?${qs.stringify({ postcode })}`, {}),
    errorMessageForUnsupportedPostcode: {
      type: 'POSTCODE_OUT_OF_AREA_ERROR',
    },
  },
};
